import axios from 'axios';
import { API_URL } from '../config/apiConfig';


// Get token from localStorage
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

// Affiliate - Get all gift cards
export const getGiftCards = async (affiliateId, status = null) => {
    try {
        const params = { affiliateId };
        if (status) {
            params.status = status;
        }

        const response = await axios.get(`${API_URL}/gift-cards`, {
            params,
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching gift cards:', error);
        throw error;
    }
};

// Affiliate - Create a new gift card
export const createGiftCard = async (giftCardData) => {
    try {
        const response = await axios.post(
            `${API_URL}/gift-cards`,
            giftCardData,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        console.error('Error creating gift card:', error);
        throw error;
    }
};

// Affiliate - Update a gift card
export const updateGiftCard = async (id, giftCardData) => {
    try {
        const response = await axios.put(
            `${API_URL}/gift-cards/${id}`,
            giftCardData,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating gift card:', error);
        throw error;
    }
};

// Affiliate - Delete a gift card
export const deleteGiftCard = async (id) => {
    try {
        const response = await axios.delete(
            `${API_URL}/gift-cards/${id}`,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        console.error('Error deleting gift card:', error);
        throw error;
    }
};

// User - Verify a gift card by code
export const verifyGiftCard = async (code, affiliateId) => {
    try {
        const response = await axios.get(`${API_URL}/gift-cards/verify`, {
            params: { code, affiliateId },
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error verifying gift card:', error);
        throw error;
    }
};

// User - Redeem a gift card
export const redeemGiftCard = async (code, affiliateId, selectedPlanId = null) => {
    try {
        const response = await axios.post(
            `${API_URL}/gift-cards/redeem`,
            { code, affiliateId, selectedPlanId },
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        console.error('Error redeeming gift card:', error);
        throw error;
    }
};

// User - Get user's redeemed gift cards
export const getUserRedeemedGiftCards = async () => {
    try {
        const response = await axios.get(`${API_URL}/gift-cards/redeemed`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching redeemed gift cards:', error);
        throw error;
    }
};

// Get all affiliates for gift card selection
export const getAffiliatesForGiftCard = async () => {
    try {
        const response = await axios.get(`${API_URL}/gift-cards/affiliates`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching affiliates:', error);
        throw error;
    }
};

